import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { assignProcessColor } from '../AiActivity.utils';

import { dotStyles, getChipStyles } from './ProcessColorChip.styles';

const ProcessColorChip = ({ processId, name }) => {
  const palette = useMemo(() => assignProcessColor(processId), [processId]);

  return (
    <Box sx={getChipStyles(palette)}>
      <Box sx={dotStyles} />
      {name}
    </Box>
  );
};

ProcessColorChip.propTypes = {
  name: PropTypes.string.isRequired,
  processId: PropTypes.string,
};

export default memo(ProcessColorChip);
